import { Injectable } from "@angular/core";
import { ActivatedRouteSnapshot, Router } from "@angular/router";
import { Observable, of } from "rxjs";
import { AuthService } from "../http/auth.service";
import { AppConfig } from "src/app/app.config";
import { BuySellFeatures } from "src/app/models/features";

@Injectable()
export class BuySellGuard {
    constructor(
        private router: Router,
        public authService: AuthService,
        public appConfig: AppConfig) { }

    public canActivate(route: ActivatedRouteSnapshot): Observable<boolean> | boolean {
        const feature = route.data['feature'];

        if (feature === BuySellFeatures.BUY_SELL) {
            if (this.isOrderCreationEnabled()) {
                return of(true);
            }

            this.router.navigateByUrl('feature/client/buy-sell/regular-investment-plan');
            return of(false);
        }

        else if (feature === BuySellFeatures.REGULAR_INVESTMENT_PLAN) {
            if (this.isRegularInvestmentPlansEnabled()) {
                return of(true)
            }

            this.router.navigateByUrl('feature/client/buy-sell/pending-orders');
            return of(false)
        }

        else if (feature === BuySellFeatures.PENDING_ORDERS) {
            if (this.isPendingOrdersEnabled()) {
                return of(true)
            }

            this.router.navigateByUrl('feature/client/buy-sell/term-deposits');
            return of(false);
        } else if(feature == BuySellFeatures.TERM_DEPOSITS) {
            if(this.isTermDepositsEnabled()){
                return of(true);
            }
            return of(false)
        }

        return of(false);
    }

    /**
      * Determines whether to show the 'Buy Sell' tab based on whether 'allowOrderCreation is enabled in the 
      * 'buySell' section of the config
      */
    private isOrderCreationEnabled(): boolean {
        return this.appConfig.appConfigSignal().features.buySell.allowOrderCreation;
    }

    /**
      * Determines whether to show the 'Regular Investment Plan' tab based on whether RIPs are enabled in
      * the 'regularInvestmentPlan' section of the config
      */
    private isRegularInvestmentPlansEnabled(): boolean {
        return this.appConfig.appConfigSignal().features.regularInvestmentPlan.enabled ?? false;
    }

    /**
    * Determines whether to show the 'Pending Orders' tab based on whether 'showPendingInvestments' is enabled
    * in the 'buySell' section of the config
    */
    private isPendingOrdersEnabled(): boolean {
        return this.appConfig.appConfigSignal().features.buySell.allowInvestor || this.appConfig.appConfigSignal().features.buySell.showPendingInvestments;
    }

    /**
     * Determines whether to show the 'Term Deposits' tab based on whether 'allowInvestor' is enabled
     * in the 'termDeposits' section of the config
     */
    private isTermDepositsEnabled(): boolean{
        return this.appConfig.appConfigSignal()?.features?.termDeposits?.allowInvestor ?? false;
    }
}